import { render, staticRenderFns } from "./witholdsingleinvoice.vue?vue&type=template&id=53fdeee2"
import script from "./witholdsingleinvoice.vue?vue&type=script&lang=js"
export * from "./witholdsingleinvoice.vue?vue&type=script&lang=js"
import style0 from "./witholdsingleinvoice.vue?vue&type=style&index=0&id=53fdeee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports